import { EmptyObject } from '../../EmptyObject';

export type ApplicationRequests = ApplicationGetTypeRequest | ApplicationGetVersionRequest | ApplicationUpgradeRequest;

export const ApplicationGetTypeRequest = 'sos.Monitoring.App.ApplicationGetTypeRequest';
export interface ApplicationGetTypeRequest {
	type: typeof ApplicationGetTypeRequest;
}

export const ApplicationGetTypeResult = 'sos.Monitoring.App.ApplicationGetTypeResult';
export interface ApplicationGetTypeResult {
	type: typeof ApplicationGetTypeResult;
	applicationType: string;
}

export const ApplicationGetVersionRequest = 'sos.Monitoring.App.ApplicationGetVersionRequest';
export interface ApplicationGetVersionRequest {
	type: typeof ApplicationGetVersionRequest;
}

export const ApplicationGetVersionResult = 'sos.Monitoring.App.ApplicationGetVersionResult';
export interface ApplicationGetVersionResult {
	type: typeof ApplicationGetVersionResult;
	version: string;
}

export const ApplicationUpgradeRequest = 'sos.Monitoring.App.ApplicationUpgradeRequest';
export interface ApplicationUpgradeRequest {
	type: typeof ApplicationUpgradeRequest;
	version: string;
	baseUrl?: string;
}

export const ApplicationUpgradeResult = 'sos.Monitoring.App.ApplicationUpgradeResult';
export interface ApplicationUpgradeResult {
	type: typeof ApplicationUpgradeResult;
	result: EmptyObject;
}
